import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { $robotoFontFamily } from "@similarweb/styles";

export const MarketResearchWrapperContainer = styled.div`
    flex-grow: 1;
    overflow-x: hidden;
    width: 100%;
`;
MarketResearchWrapperContainer.displayName = "MarketResearchWrapperContainer";

export const StyledSearchWrapper = styled.div`
    position: relative;
`;
export const StyledBadgeWrapper = styled.div`
    position: absolute;
    top: -28px;
    right: 0;
`;

export const PlaceholderText = styled.span`
    color: ${colorsPalettes.carbon["300"]};
    font-family: ${$robotoFontFamily};
    font-size: 14px;
    margin-left: 32px;
`;

export const BoldPlaceholderText = styled.span`
    font-weight: 500;
`;
